var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[(_vm.site === 'holding')?_c('HoldingIcon',{staticClass:"logo__image"}):_c('CapitalIcon',{staticClass:"logo__image"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }